export default __webpack_public_path__ + "static/media/terms_and_conditions.20a49920.pdf";